import { render, staticRenderFns } from "./UncompletedOrder.vue?vue&type=template&id=104de722&scoped=true"
import script from "./UncompletedOrder.vue?vue&type=script&lang=js"
export * from "./UncompletedOrder.vue?vue&type=script&lang=js"
import style0 from "./UncompletedOrder.vue?vue&type=style&index=0&id=104de722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104de722",
  null
  
)

export default component.exports